var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bcloaded)?_c('ul',{staticClass:"breadcrumbs"},_vm._l((_vm.breadbar),function(row,i){return _c('li',{key:i},[_c('RouterLink',{attrs:{"to":row.url},domProps:{"innerHTML":_vm._s(row.desc)}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }